import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./analyticsInstrument.html";
class AnalyticsInstrument extends LightningElement {
  constructor(...args) {
    super(...args);
    this.type = void 0;
    this.buttonType = void 0;
    this.context = void 0;
    this.positionIndex = void 0;
    this.hasLoaded = false;
    this.hasShown = false;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.handleHover = _event => {};
    this.handleClick = event => {
      if (!event.analyticsHandled) {
        event.analyticsHandled = true;
        let extraProps = {};
        if (this.type === 'button') {
          extraProps = {
            buttonType: this.buttonType
          };
        }
        const analyticsEvent = this.buildAnalyticsEvent('click', extraProps);
        this.dispatchEvent(analyticsEvent);
      }
    };
    this.handleChange = event => {
      const input = event.target;
      const checked = input.tagName.toLowerCase() === 'select' ? true : input.checked;
      const extraProps = {
        checked,
        value: input.value
      };
      const analyticsEvent = this.buildAnalyticsEvent('click', extraProps);
      this.dispatchEvent(analyticsEvent);
    };
    this.handleLoaded = () => {
      const analyticsEvent = this.buildAnalyticsEvent('tileLoaded');
      this.dispatchEvent(analyticsEvent);
    };
    this.handleShown = () => {
      const eventType = this.getShownEventType();
      const extraProps = Number.isNaN(this.positionIndex) ? {} : {
        positionIndex: this.positionIndex
      };
      const analyticsEvent = this.buildAnalyticsEvent(eventType, extraProps);
      this.dispatchEvent(analyticsEvent);
    };
    this.isElementOnScreen = elm => {
      const rect = elm.getBoundingClientRect();
      if (this.rectIsEmpty(rect)) {
        return false;
      }
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewHeight && rect.right <= viewWidth;
    };
    this.scrollHandler = () => {
      if (!this.hasShown) {
        const slot = this.template.querySelector('slot');
        const elements = slot.assignedElements();
        if (elements && elements.length > 0) {
          if (this.isElementOnScreen(elements[0])) {
            this.handleShown();
            this.hasShown = true;
          }
        }
      }
    };
  }
  renderedCallback() {
    /*
        Try to register listeners on render. If elements are not available yet
        we will register them on slot change
    */
    this.handleSlotChange();
  }
  handleSlotChange() {
    const elements = this.assignedElements();
    if (!elements || elements.length === 0) {
      return;
    }
    switch (this.type) {
      case 'link':
      case 'button':
      case 'tag':
      case 'loginNavLink':
        this.registerButtonListeners(elements);
        break;
      case 'listingTile':
      case 'contentTile':
        this.registerTileListeners(elements);
        break;
      case 'image':
        this.registerShownListener(elements);
        break;
      case 'filter':
        this.registerChangeListener(elements);
        break;
      default:
        break;
    }
  }
  registerButtonListeners(elements) {
    if (!this.hasLoaded) {
      elements[0].addEventListener('mouseover', this.handleHover);
      elements[0].addEventListener('click', this.handleClick);
      this.hasLoaded = true;
    }
  }
  registerChangeListener(elements) {
    // add listeners to inputs
    elements[0].querySelectorAll('input').forEach(input => {
      // @ts-expect-error * Automated Type Error Fix
      input.addEventListener('change', this.handleChange);
    });
    // add listeners to select
    let element = elements[0];
    while (element) {
      element.querySelectorAll('select').forEach(select => {
        // @ts-expect-error * Automated Type Error Fix
        select.addEventListener('change', this.handleChange);
      });
      // @ts-expect-error * Automated Type Error Fix
      element = element.nextElementSibling;
    }
  }
  registerTileListeners(elements) {
    if (!this.hasLoaded) {
      elements[0].addEventListener('click', this.handleClick);
      elements[0].addEventListener('mouseover', this.handleHover);
      window.addEventListener('scroll', this.scrollHandler);
      this.handleLoaded();
      this.hasLoaded = true;
    }
    this.onLoadShown(elements[0]);
  }
  registerShownListener(elements) {
    if (!this.hasLoaded) {
      window.addEventListener('scroll', this.scrollHandler);
    }
    this.onLoadShown(elements[0]);
  }
  onLoadShown(elm) {
    /*
    Without setTimeout function by the time the method isElementOnScreen
    was called the listing tile wasn't rendered yet so we weren't able to tell
    if the tile was on screen
    So we could miss tile view events if the user leave the page without scrolling
    */
    // eslint-disable-next-line @lwc/lwc/no-async-operation
    setTimeout(() => {
      if (!this.hasShown) {
        const onScreen = this.isElementOnScreen(elm);
        if (onScreen) {
          this.handleShown();
          this.hasShown = true;
        }
      }
    }, 0);
  }
  assignedElements() {
    const slot = this.template?.querySelector('slot');
    return slot?.assignedElements() || [];
  }
  disconnectedCallback() {
    const elements = this.assignedElements();
    if (elements && elements.length > 0) {
      elements[0].removeEventListener('mouseover', this.handleHover);
      elements[0].removeEventListener('click', this.handleClick);
    }
    window.removeEventListener('scroll', this.scrollHandler);
  }
  buildAnalyticsEvent(eventType, extraProps = {}) {
    return new CustomEvent('analytics', {
      bubbles: true,
      composed: true,
      detail: {
        elementType: this.type,
        eventType,
        ...extraProps,
        ...this.context
      }
    });
  }
  rectIsEmpty(rect) {
    return rect.bottom === 0 && rect.top === 0;
  }
  getShownEventType() {
    if (['listingTile', 'contentTile'].includes(this.type)) {
      return 'tileShown';
    }
    if (this.type === 'image') {
      return 'imageShown';
    }
    return null;
  }
  addListenerToScrollEvent(element) {
    element?.addEventListener('scroll', this.scrollHandler);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AnalyticsInstrument, {
  publicProps: {
    type: {
      config: 0
    },
    buttonType: {
      config: 0
    },
    context: {
      config: 0
    },
    positionIndex: {
      config: 0
    }
  },
  publicMethods: ["addListenerToScrollEvent"],
  fields: ["hasLoaded", "hasShown", "handleHover", "handleClick", "handleChange", "handleLoaded", "handleShown", "isElementOnScreen", "scrollHandler"]
});
const __lwc_component_class_internal = _registerComponent(AnalyticsInstrument, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;